import aa from 'search-insights';

export const setInsightsUserToken = (token: string) => {
  aa('setUserToken', token);
};
